import { updatableListActions } from '../../GeneralListFunctions/actionFactory'
export default updatableListActions('MAIL_USER')
